module.exports = __webpack_public_path__ + "static/media/Chiu.cb330a21.jpeg";